import { useState } from "react";
import "./index.css";

const ProdSubBox = ({
  title,
  itemId,
  desc,
  isInput,
  handleUpdate,
  handleCreate,
}) => {
  const [isEdit, setIsEdit] = useState(false);
  const [text, setText] = useState(title);

  const handleKeyDown = (e) => {
    if (e.key === "Enter") {
      if (itemId) {
        handleUpdate(itemId, text);
        setIsEdit(null);
      } else {
        handleCreate(text, setText);
        setIsEdit(null);
      }
    }
  };

  const handleBlur = () => {
    if (itemId) {
      handleUpdate(itemId, text);
      setIsEdit(null);
    } else {
      handleCreate(text, setText);
      setIsEdit(null);
    }
  };

  return (
    <div className="prod-sub-box-bg">
      <div
        style={{ width: "100%" }}
        onClick={isInput ? () => setIsEdit(!isEdit) : null}
      >
        {isEdit ? (
          <input
            type="text"
            value={text}
            onChange={(e) => setText(e.target.value)}
            onBlur={handleBlur}
            onKeyDown={(e) => handleKeyDown(e)}
            autoFocus
            placeholder={title}
            style={{
              width: "100%",
              padding: "4px",
              border: "none",
              backgroundColor: "transparent",
              fontSize: "14px",
            }}
          />
        ) : (
          <h5 style={{ margin: 0, marginBottom: "5px", fontWeight: "bold" }}>
            {title}
          </h5>
        )}

        <p style={{ padding: 0, marginBottom: 0 }}>{desc}</p>
      </div>
    </div>
  );
};

export default ProdSubBox;
